import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FilterOption } from 'models/Filters';
import { LISTING_STAGE } from 'models/Listing';
import { LISTING_STATUS_LABEL } from 'data/dealStatus';
import MultiFilter from 'components/MultiFilter';

import './ActivityMetricsFilters.styles.scss';

export const HAS_LISTING_FILTER_KEY = 'hasListing';
export const LISTING_STATUS_FILTER_KEY = 'listingStatus';

type ActivityMetricsFiltersProps = {
  className?: string;
};

const ActivityMetricsFilters: FC<ActivityMetricsFiltersProps> = ({
  className,
}) => {
  const classes = classNames('activity-metrics-filters', className);

  const { t } = useTranslation();

  const filterOptions = useMemo(
    () =>
      [
        {
          value: HAS_LISTING_FILTER_KEY,
          label: t('listingAdded'),
          options: [
            { value: 'true', label: t('yes') },
            { value: 'false', label: t('no') },
          ],
        },
        {
          value: LISTING_STATUS_FILTER_KEY,
          label: t('listingStatus'),
          options: Object.values(LISTING_STAGE).map((value) => ({
            value,
            label: t(LISTING_STATUS_LABEL[value]),
          })),
        },
      ] as FilterOption[],
    [t],
  );

  return <MultiFilter className={classes} filterOptions={filterOptions} />;
};

export default ActivityMetricsFilters;
